import React from 'react';
import MeetingFilteredList from './MeetingFilteredList';

const PastMeetings = () => {
  return (
    <MeetingFilteredList 
      title="Geçmiş Görüşmeler"
      filterType="past"
    />
  );
};

export default PastMeetings;
